module.exports = __webpack_public_path__ + "static/media/block-2-item-4.f12c9a38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-2-item-4.jpg
// module id = 1254
// module chunks = 270